import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconShapesInSquare = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" size={size} {...props}>
        <StyledStrokedGroup color={color}>
            <StyledPath
                color="none"
                strokeWidth="1.5px"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1 1h30v30H1V1Z"
            />
            <StyledPath
                color="none"
                strokeWidth="1.5px"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.125 9.303A2 2 0 0 1 16 8h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2M18 19a6 6 0 1 1-6-6M15.37 14.035a6.015 6.015 0 0 1 1.697 1.741"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
